module.exports = __webpack_public_path__ + "img/VolumeShape.037e09ad.png";